import { PhaseEffect } from "./PhaseEffect";
import { ResourceType, TurnPhase } from "./constant";
import { AgentEffectCommands, AgentEffectDescription } from "./effect";

const { RoundStart, CombatEnd, EndGame, Play, Reveal, Shop } = TurnPhase;

const {
  cause,
  and,
  combatPointForReavealedCard,
  drawIntrigue,
  trashCard,
  victoryPoint,
  payResource,
  discardCard,
  draw,
  garnison,
  ignoreOccupiedAgentSlots,
  chooseFactionChange,
  influencePoints,
  hasSiege,
  combatPoint,
  multipleFactionChange,
  solaris,
  trashMe,
  canBuyOnDeck,
  water,
  hasNCardTSMF,
  hasFactionsLevel,
  hasMinInfluencePoints,
  trashCardInPlay,
  spyStallites,
  recycleIntrigueCards,
  winTiebreakers,
  hasDeployedDreadnaught,
  shippingTrackTroop,
  drawIntrigueCardsToCheckpoint,
} = AgentEffectCommands;

const chooseFactionUp = chooseFactionChange(1);

export type TechTile = {
  id: string;
  cost: number;
  buyEffects?: AgentEffectDescription[];
  effects: PhaseEffect[];
  isExhausted?: boolean;
};

export const techTiles: TechTile[] = [
  {
    id: "Artillery",
    cost: 1,
    effects: [
      {
        phase: Reveal,
        effects: [combatPointForReavealedCard(1)],
      },
    ],
  },
  {
    id: "Chaumurky",
    cost: 4,
    buyEffects: [drawIntrigue, drawIntrigue],
    effects: [
      {
        phase: EndGame,
        effects: [winTiebreakers],
      },
    ],
  },
  {
    id: "Detonation Devices",
    cost: 3,
    effects: [
      {
        phase: CombatEnd,
        effects: [cause(hasDeployedDreadnaught).effect(victoryPoint(1))], // 1 VP when you win a conflict with a dreadnought and return dreadnought to supply instead of taking control of a board space
      },
    ],
  },
  {
    id: "Disposal Facility",
    cost: 3,
    buyEffects: [trashCard],
    effects: [
      {
        phase: Reveal,
        effects: [cause(hasMinInfluencePoints(6)).effect(trashCardInPlay)],
      },
    ],
  },
  {
    id: "Flagship",
    cost: 8,
    buyEffects: [victoryPoint(1)],
    effects: [
      {
        phase: Play,
        effects: [
          cause(payResource({ amount: 4, type: ResourceType.Solaris })).effect(
            garnison(3)
          ),
        ],
      },
    ],
  },
  {
    id: "Holoprojectors",
    cost: 3,
    effects: [
      {
        phase: Play,
        effects: [cause(discardCard).effect(draw)],
      },
    ],
  },
  {
    id: "Holtzman Engine",
    cost: 6,
    effects: [
      {
        phase: RoundStart,
        effects: [draw],
      },
      {
        phase: EndGame,
        effects: [cause(hasNCardTSMF(2)).effect(victoryPoint(1))],
      },
    ],
  },
  {
    id: "Invasion Ships",
    cost: 5,
    buyEffects: [garnison(4)],
    effects: [
      {
        phase: Play,
        effects: [cause(discardCard).effect(ignoreOccupiedAgentSlots)],
      },
    ],
  },
  {
    id: "Memocorders",
    cost: 2,
    buyEffects: [chooseFactionUp],
    effects: [
      {
        phase: EndGame,
        effects: [
          cause(hasFactionsLevel({ minLevel: 3 })).effect(victoryPoint(1)),
        ],
      },
    ],
  },
  {
    id: "Minimic Film",
    cost: 2,
    effects: [
      {
        phase: Reveal,
        effects: [influencePoints(1)],
      },
    ],
  },
  {
    id: "Restricted Ordinance",
    cost: 4,
    effects: [
      {
        phase: Reveal,
        effects: [cause(hasSiege).effect(combatPoint(4))],
      },
    ],
  },
  {
    id: "Shuttle Fleet",
    cost: 6,
    buyEffects: [
      multipleFactionChange({
        factionCount: 2,
        factionUpdate: 1,
      }),
    ],
    effects: [
      {
        phase: RoundStart,
        effects: [solaris(2)],
      },
    ],
  },
  {
    id: "Sonic Snoopers",
    cost: 2,
    buyEffects: [drawIntrigue],
    effects: [
      {
        phase: Play,
        effects: [
          cause(and([trashMe, recycleIntrigueCards])).effect(
            drawIntrigueCardsToCheckpoint
          ),
        ],
      },
    ],
  },
  {
    id: "Spaceport",
    cost: 5,
    buyEffects: [draw, draw],
    effects: [
      {
        phase: Shop,
        effects: [canBuyOnDeck],
      },
    ],
  },
  {
    id: "Spy Satellites",
    cost: 4,
    effects: [
      {
        phase: Play,
        effects: [
          cause(
            and([trashMe, payResource({ amount: 3, type: ResourceType.Spice })])
          ).effect(victoryPoint(1)),
        ],
      },
      {
        phase: EndGame,
        effects: [spyStallites],
      },
    ],
  },
  {
    id: "Training Drones",
    cost: 3,
    effects: [
      {
        phase: Play,
        effects: [garnison(1)],
      },
    ],
  },
  {
    id: "Troop Transports",
    cost: 2,
    effects: [
      {
        phase: Play,
        effects: [shippingTrackTroop],
        forceNotPlayable: true,
      },
    ],
  },
  {
    id: "Windtraps",
    cost: 2,
    buyEffects: [water(1)],
    effects: [
      {
        phase: CombatEnd,
        effects: [water(1)],
      },
    ],
  },
];
